module.exports = __webpack_public_path__ + "img/about-curator-1.0e5af55d.png";